import _ from 'lodash'
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import GatsbyLink from 'gatsby-link'

import { colors, mapProps, media } from '../theme'

export const Link = styled(GatsbyLink)`
  font-size: 0.9rem;
  font-weight: 600;
  ${'' /* font-family: 'Averta Std'; */} padding-bottom: 0.14rem;
  border-bottom: .125rem solid rgba(0, 0, 0, 0.1);

  color: ${colors.gray[7]};

  &:hover {
    color: ${colors.gray[7]};
    border-color: ${colors.gray[8]};
  }

  ${mapProps({
    active: css`
      border-color: ${colors.gray[8]};`,
    color: {
      highlight() {
        const color = colors.indigo[5]
        // const darker = darken(0.2, color)
        const darker = colors.indigo[9]
        return css`
          color: ${color};
          border-color: ${color};
          &:hover {
            color: ${darker};
            border-color: ${darker};
          }`
      },
    },
  })};
`

export default Link



// WEBPACK FOOTER //
// ./src/styleguide/Link.js